import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { BundleProduct, TravelerPrice } from '@eti/types';
import { connect } from 'react-redux';
import getTranslatedTexts from '../../../common/text-resolvers/utils/getTranslatedTexts';
import { TRIP_CANCELLATION_PROTECTION } from '../../../products';
import ManulifeInsuranceContainer from '../../common/containers/ManulifeInsuranceContainer';
import { getTravelerNames } from '../../common/utils/travelersNames';
import { useImperativeQuery, getProvinces, getTravelers, handleFetchPrice } from '../../common/utils/utils';
import { GET_ANCILLARY_ITEM } from '../../common/utils/query';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = TRIP_CANCELLATION_PROTECTION;
const isSelectableTexts = {
  additionalInformation: 'tripCancellationProtectionAdditionalInformation',
  readMoreContent: 'tripCancellationProtectionReadMoreModalContent',
  text: 'tripCancellationProtectionAbstract',
  title: 'tripCancellationProtectionTitle'
};
const isNotSelectableTexts = {
  additionalInformation: 'tripCancellationProtectionAdditionalInformationWhenNotSelectable',
  readMoreContent: 'tripCancellationProtectionReadMoreModalContentWhenNotSelectable',
  text: 'tripCancellationProtectionAbstractWhenNotSelectable',
  title: 'tripCancellationProtectionTitleWhenNotSelectable'
};
const generalTexts = {
  persuasionContent: 'tripCancellationProtectionPersuasionContent',
  confirmationContent: 'tripCancellationProtectionConfirmationContent',
  confirmText: 'tripCancellationProtectionConfirmationYes',
  declineText: 'tripCancellationProtectionConfirmationNo',
  upSell: 'tripCancellationProtectionUpSellText',
  notSelectedLabel: 'Products.Price.Label.Only'
};
const getTexts = isSelectable => ({
  ...generalTexts,
  ...(isSelectable ? isSelectableTexts : isNotSelectableTexts)
});
const TripCancellationProtection = _ref => {
  let {
    brand,
    bundleData,
    checkedBaggageSummary,
    className,
    confirmation,
    dispatch,
    form,
    isSeatMapModalOpen,
    isSelectable = true,
    productIncludedTexts,
    productPosition,
    productSpecificTexts,
    readMore,
    seatMapCallback,
    setIsSeatMapModalOpen,
    shouldShowImage,
    shouldShowMandatoryChoiceText,
    shouldShowPricePerBound,
    travelerPrices,
    travelerNames,
    order,
    sellSpecification
  } = _ref;
  const {
    t
  } = useTranslation();
  const translatedTexts = getTranslatedTexts(getTexts(isSelectable), t);
  const travelerLabel = t('Postbooking.Traveler.Description');
  const fetchPrice = useImperativeQuery(GET_ANCILLARY_ITEM, {
    fetchPolicy: 'no-cache'
  });
  const travelers = getTravelers(order, travelerNames, travelerLabel);
  const provinces = getProvinces(sellSpecification);
  return /*#__PURE__*/_jsx(ManulifeInsuranceContainer, {
    ...translatedTexts,
    brand: brand,
    bundleData: bundleData,
    checkedBaggageSummary: checkedBaggageSummary,
    className: className,
    confirmation: confirmation,
    dispatch: dispatch,
    form: form,
    hasLogo: true,
    isSeatMapModalOpen: isSeatMapModalOpen,
    isSelectable: isSelectable,
    onFetchPrice: handleFetchPrice(fetchPrice, TRIP_CANCELLATION_PROTECTION.id),
    productId: PRODUCT_ID,
    productIncludedTexts: productIncludedTexts,
    productName: PRODUCT_NAME,
    productPosition: productPosition,
    productSpecificTexts: productSpecificTexts,
    provinces: provinces,
    readMore: readMore,
    seatMapCallback: seatMapCallback,
    setIsSeatMapModalOpen: setIsSeatMapModalOpen,
    shouldShowImage: shouldShowImage,
    shouldShowMandatoryChoiceText: shouldShowMandatoryChoiceText,
    shouldShowPricePerBound: shouldShowPricePerBound,
    travelerPrices: travelerPrices,
    travelers: travelers
  });
};
TripCancellationProtection.propTypes = {
  brand: PropTypes.string,
  bundleData: BundleProduct,
  checkedBaggageSummary: PropTypes.shape({
    tripSummaries: PropTypes.arrayOf(PropTypes.shape({
      baggageDetails: PropTypes.shape({
        pieces: PropTypes.any,
        weight: PropTypes.number,
        weightUnit: PropTypes.string
      }),
      baggageStatus: PropTypes.string,
      travelerId: PropTypes.string
    }))
  }),
  className: PropTypes.string,
  confirmation: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  dispatch: PropTypes.func,
  form: PropTypes.string,
  isSeatMapModalOpen: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onFetchPrice: PropTypes.any,
  order: PropTypes.any,
  productIncludedTexts: PropTypes.any,
  productPosition: PropTypes.number,
  productSpecificTexts: PropTypes.string,
  provinces: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  readMore: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  seatMapCallback: PropTypes.func,
  sellSpecification: PropTypes.any,
  setIsSeatMapModalOpen: PropTypes.func,
  shouldShowImage: PropTypes.bool,
  shouldShowMandatoryChoiceText: PropTypes.bool,
  shouldShowPricePerBound: PropTypes.bool,
  travelerNames: PropTypes.arrayOf(PropTypes.shape({
    fullName: PropTypes.string,
    initials: PropTypes.string,
    travelerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  travelerPrices: PropTypes.arrayOf(TravelerPrice)
};
const mapStateToProps = (state, _ref2) => {
  let {
    form,
    order
  } = _ref2;
  const travelerNames = getTravelerNames(form, state, order.travelers);
  return {
    travelerNames
  };
};
export default connect(mapStateToProps)(TripCancellationProtection);
//# sourceMappingURL=TripCancellationProtection.js.map